export enum StockManagementConfigurationTypeEnum {
  weeklyEnabled = 'Weekly Enabled',
  monthlyEnabled = 'Monthly Enabled'
}
